
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-we-compare",
      function () {
        return require("private-next-pages/how-we-compare.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-we-compare"])
      });
    }
  